import React from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";

export type Props = {
  /**
   * ボタンがクリックされた場合に呼び出されます
   */
  onClick?: () => void;
};

/**
 * チャート編集ボタンを表示します
 * @param {Props} props - ボタンパラメータ
 * @returns チャート編集ボタン
 */
export default function ChartEditButton(props: Props) {
  return (
    <Tooltip title="edit" placement="left" arrow>
      <IconButton aria-label="edit" onClick={props.onClick}>
        <EditIcon />
      </IconButton>
    </Tooltip>
  );
}
